export const BASE_URL = "https://api.trdr.money";
export const ENGINE_API_URL = `${BASE_URL}/api/v1/engine`;
export const ENGINE_URL = `${BASE_URL}/api/v1/engine`;

// Frontend Pure Live Mandate: Simulation is removed from the dealer portal
export const ENABLE_SIMULATION = false;
export const DEFAULT_ENVIRONMENT = "LIVE";
